var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 2.3125C10.0125 2.09375 10.25 1.69687 10.25 1.25C10.25 0.559375 9.69063 0 9 0C8.30938 0 7.75 0.559375 7.75 1.25C7.75 1.7 7.9875 2.09375 8.34375 2.3125L6.55313 5.89375C6.26875 6.4625 5.53125 6.625 5.03438 6.22813L2.25 4C2.40625 3.79063 2.5 3.53125 2.5 3.25C2.5 2.55938 1.94063 2 1.25 2C0.559375 2 0 2.55938 0 3.25C0 3.94062 0.559375 4.5 1.25 4.5H1.27188L2.7 12.3562C2.87188 13.3062 3.7 14 4.66875 14H13.3313C14.2969 14 15.125 13.3094 15.3 12.3562L16.7281 4.5H16.75C17.4406 4.5 18 3.94062 18 3.25C18 2.55938 17.4406 2 16.75 2C16.0594 2 15.5 2.55938 15.5 3.25C15.5 3.53125 15.5938 3.79063 15.75 4L12.9656 6.22813C12.4688 6.625 11.7313 6.4625 11.4469 5.89375L9.65625 2.3125Z",
    fill: "#00FFE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownDark);
export default __webpack_public_path__ + "static/media/crownDark.46f119bc0f007be9489a07fbf8736440.svg";
export { ForwardRef as ReactComponent };